// @ts-strict-ignore
import { ChannelRB } from 'rainbow-web-sdk/models/channel.model';
import { Contact } from 'rainbow-web-sdk/models/contact.model';

class FileViewerType {
    public static USER = "user";
    public static ROOM = "room";
}

/**
 * This class is used to represent a File Viewer who is the list of persons (individual or a bubble) that can access (download) the file.
 */
export class FileViewer {
    public viewerId: string = null;
    public type: FileViewerType = null;
    public contact: Contact = null;
    public room: any = null;
    public channel: ChannelRB = null;

    public static createFromData(data: any): FileViewer[] {
        return data.map((viewerData: any) => {
            return new FileViewer(viewerData.viewerId, viewerData.type);
        });
    }

    private constructor(viewerId: string, type: FileViewerType) {

        /**
         * @param viewerId - The id of the viewer
         */
        this.viewerId = viewerId;

        /**
         * @param type - The type of viewer: 'user' for a contact or 'room' for a bubble
         */
        this.type = type;
    }
}
